"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 866 ], {
  866: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("reviews-banner") || customElements.define("reviews-banner", class extends HTMLElement {
      el=this.querySelector(":scope > div");
      load() {
        const userId = location.host.includes("uklash.es") ? "92878cfd-5fb8-4779-82d1-75ed7a30d544" : "f20edefd-92b0-4555-a2ad-efa1a098ee12";
        fetch(`https://api.okendo.io/v1/stores/${userId}/review_aggregate`).then((response => response.json())).then((data => {
          this.innerHTML = this.innerHTML.replace("[[reviews]]", data.reviewAggregate.reviewCount.toLocaleString()), 
          this.classList.remove("max-h-0");
        })).catch((error => {
          console.warn(error);
        }));
      }
      constructor() {
        super();
      }
      connectedCallback() {
        this.load();
      }
    }));
  }
} ]);